type PdfProps = {
    source: {
        uri: string;
    };
};

const Pdf = ({ source }: PdfProps) => {
    return <iframe src={source.uri} width="100%" height="100%" />;
};

export default Pdf;
